import React from 'react'
import Header from './Header';
import Addform from './Addform';
import Footer from './Footer';

const Add = () => {
  return (
    <>
    <Header/>
    <Addform/>
    <Footer/>
    </>
  )
}

export default Add;